<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="2800"
      :manual-pagination="true"
      pdf-content-width="800px"
      ref="html2Pdf"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content" style="background-color: white; padding: 20px">
        <div style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; background-color: white">
          <div class="pdf-title">Referencias de {{ nombrePersonal || 'DATO NO REGISTRADO' }}</div>
          <div v-if="photo" style="text-align: right; margin: 20px 0">
            <img :src="photo.src" crossOrigin="anonymous" width="100" height="100" />
          </div>
          <div v-for="tipoReferencia in tipoReferencias" :key="tipoReferencia.id">
            <div v-if="filteredReferenciasByTipo(tipoReferencia.id).length > 0" style="margin-top: 30px">
              <div style="font-size: 18px; font-weight: bold; margin-bottom: 15px">
                TIPO DE REFERENCIA(S): {{ tipoReferencia.title }}
              </div>
              <div
                v-for="referencia in filteredReferenciasByTipo(tipoReferencia.id)"
                :key="referencia.idReferencia"
                style="border: 1px solid black; margin-bottom: 15px; padding: 10px"
              >
                <div><strong>Nombre:</strong> {{ referencia.nombre }}</div>
                <div><strong>Teléfono:</strong> {{ referencia.telefono }}</div>
                <template v-if="tipoReferencia.id === 1">
                  <div style="margin-top: 8px">
                    <strong>Años de ser vecinos:</strong>
                    {{ referencia.tiempoConocerse || 'DATO NO REGISTRADO' }}
                  </div>
                  <div style="margin-top: 10px; font-weight: bold">DIRECCIÓN:</div>
                  <div style="margin-top: 10px; font-size: 12px">
                    <div><strong>Calle:</strong> {{ referencia.calle || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Entre calle:</strong> {{ referencia.entrecalles || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Entre calle 2:</strong> {{ referencia.entrecalles2 || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Número exterior:</strong> {{ referencia.exterior || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Número interior:</strong> {{ referencia.interior || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Colonia:</strong> {{ referencia.colonia || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Código postal:</strong> {{ referencia.cp || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Estado:</strong> {{ referencia.estado || 'DATO NO REGISTRADO' }}</div>
                    <div><strong>Municipio:</strong> {{ municipioNombre(referencia.fk_idmunicipio) }}</div>
                    <div><strong>Localidad:</strong> {{ referencia.localidad || 'DATO NO REGISTRADO' }}</div>
                  </div>
                </template>
                <template v-else-if="tipoReferencia.id === 2">
                  <div style="margin-top: 8px">
                    <strong>Años de conocerlo:</strong>
                    {{ referencia.tiempoConocerse || 'DATO NO REGISTRADO' }}
                  </div>
                  <div style="margin-top: 8px">
                    <strong>¿Cómo lo conoció?:</strong>
                    {{ referencia.comoConocio || 'DATO NO REGISTRADO' }}
                  </div>
                </template>
                <template v-else-if="isLaboralTipo(referencia.tipo)">
                  <div style="margin-top: 8px">
                    <strong>Cargo:</strong> {{ referencia.cargo || 'DATO NO REGISTRADO' }}
                  </div>
                  <div style="margin-top: 8px">
                    <strong>Corporación:</strong> {{ referencia.corporacion || 'DATO NO REGISTRADO' }}
                  </div>
                  <div style="margin-top: 8px">
                    <strong>Tiempo laborado:</strong>
                    {{ referencia.tiempoLaborado || 'DATO NO REGISTRADO' }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { TIPO_REFERENCIAS_LABORALES } from '@src/modules/referencias/domain/TIPO_REFERENCIAS'
import { mapGetters } from 'vuex'

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    referencias: {
      type: Array,
      default: () => [],
    },
    nombrePersonal: {
      type: String,
      default: '',
    },
    personal: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      options: {
        filename: 'Referencias',
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          compress: true,
        },
        margin: [10, 0],
      },
      tipoReferencias: [
        { id: 1, title: 'Vecinal' },
        { id: 2, title: 'Personal' },
        { id: 3, title: 'Laboral' },
      ],
      photo: null,
    }
  },

  computed: {
    ...mapGetters('municipio', ['getMunicipios']),
    ...mapGetters('estado', ['getEstados']),
    municipios() {
      return this.getMunicipios
    },
    estados() {
      return this.getEstados
    },
  },

  methods: {
    generateReport() {
      if (this.personal && this.personal.foto) {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          this.photo = img
          this.$nextTick(() => {
            this.$refs.html2Pdf.generatePdf()
          })
        }
        img.onerror = () => {
          this.photo = null
          this.$refs.html2Pdf.generatePdf()
        }
        img.src = this.personal.foto
      } else {
        this.photo = null
        this.$refs.html2Pdf.generatePdf()
      }
    },

    isLaboralTipo(tipo) {
      return TIPO_REFERENCIAS_LABORALES.includes(tipo)
    },

    filteredReferenciasByTipo(id_tipo_referencia) {
      if (id_tipo_referencia === 3) {
        // Laborales: incluye todos los tipos laborales
        return this.referencias.filter((referencia) => TIPO_REFERENCIAS_LABORALES.includes(referencia.tipo))
      }
      // Vecinal y Personal
      return this.referencias.filter((referencia) => referencia.tipo === id_tipo_referencia)
    },

    municipioNombre(idMunicipio) {
      const municipio = this.municipios.find((m) => m.id === idMunicipio)
      return municipio ? municipio.nombre : 'DATO NO REGISTRADO'
    },
  },
}
</script>

<style scoped>
.bordered {
  border: 1px solid black;
}
.font {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
}
.pdf-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}
.direccion-section {
  font-size: 12px;
}
.dense-spacing .v-row {
  margin-bottom: 0;
}
.dense-spacing .v-col {
  padding-top: 2px;
  padding-bottom: 2px;
}

/* Forzar fondo blanco para el PDF */
::v-deep .v-application {
  background-color: white !important;
}
::v-deep .v-container {
  background-color: white !important;
}
::v-deep .v-row {
  background-color: white !important;
}
::v-deep .v-col {
  background-color: white !important;
}
::v-deep .white {
  background-color: white !important;
}
::v-deep .v-application--wrap {
  background-color: white !important;
}
::v-deep * {
  background-color: white !important;
}
</style>
